import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import Icon from "../../../components/general/Icon/Icon";
import * as s from "./AlertBanner.module.scss";

type AlertBannerProps = {
	children: string;
	onClick?: () => void;
	ariaLabelClose?: string;
};

const AlertBanner: FC<AlertBannerProps> = ({
	children,
	onClick,
	ariaLabelClose,
}) => (
	<div className={cn(s.alertContainer)}>
		<p className={cn(s.alertText)}>{children}</p>
		<button
			className={cn(s.iconContainer)}
			onClick={onClick}
			aria-label={ariaLabelClose}
		>
			<Icon
				icon="close"
				aria-label={ariaLabelClose}
				className={cn(s.closeIcon)}
				color="#FFFFFF"
			/>
		</button>
	</div>
);

export default AlertBanner;
